var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.616117 11.1161C0.127961 11.6043 0.127961 12.3957 0.616117 12.8839C1.10427 13.372 1.89573 13.372 2.38388 12.8839L7.38388 7.88388C7.87204 7.39573 7.87204 6.60427 7.38388 6.11612L2.38388 1.11612C1.89573 0.62796 1.10427 0.62796 0.616117 1.11612C0.127961 1.60427 0.127961 2.39573 0.616117 2.88388L4.73223 7L0.616117 11.1161Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.8904c6cf261a57e6fd2501597895a352.svg";
export { ForwardRef as ReactComponent };